// extracted by mini-css-extract-plugin
export default {"composer__actions":"composer__actions__8bn-v"};